var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBell = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 21",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.213 18.53c-.04.168-.06.316-.06.506C6.154 20.113 6.989 21 8 21s1.846-.887 1.846-1.964c0-.169-.02-.338-.06-.507H6.214zM16 15.93a.872.872 0 0 0-.19-.454c-.022-.022-1.715-1.905-1.715-6.883 0-3.874-2.54-5.498-4.635-5.996V1.472C9.46.67 8.804 0 8.021 0s-1.46.671-1.46 1.472v1.147c-2.095.498-4.635 2.1-4.635 5.996 0 4.978-1.693 6.861-1.714 6.861a.755.755 0 0 0-.212.455v1.363h16v-1.363z"
  })));
};
export default SvgBell;